import { getTransactionTypeText } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/common/getTransactionTypeText.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import { ExpectedTransactionType, TransactionType } from '@dealstack/shared/lib/generated';

type TCapManageKeyTranslator = (
	key: Parameters<TranslateFunction<I18Namespaces.CAP_MANAGE>>[0]
) => string;

/**
 * ExpectedTransactionType holds the same values as its TransactionType counterparts but is a
 * separate enum, so map rather than cast — a new expected value then fails the build instead
 * of silently losing its label.
 */
const AS_TRANSACTION_TYPE: Record<ExpectedTransactionType, TransactionType> = {
	[ExpectedTransactionType.ISSUE]: TransactionType.ISSUE,
	[ExpectedTransactionType.TRANSFER]: TransactionType.TRANSFER,
	[ExpectedTransactionType.REDEMPTION]: TransactionType.REDEMPTION,
	[ExpectedTransactionType.CANCELLATION]: TransactionType.CANCELLATION,
};

/** The cap-table label for an allocation's expected transaction type. */
export const getExpectedTransactionTypeText = (
	type: ExpectedTransactionType | null | undefined,
	tCapManage: TCapManageKeyTranslator
): string => (type ? getTransactionTypeText(AS_TRANSACTION_TYPE[type], tCapManage) : '');

export const getExpectedTransactionTypeOptions = (tCapManage: TCapManageKeyTranslator) =>
	Object.values(ExpectedTransactionType).map((value) => ({
		value,
		label: getExpectedTransactionTypeText(value, tCapManage),
	}));
